<template> 
  <div 
    class="Slider overflow-hidden justify-center my-8 "
    :class="boxClasses"
  >
    <div 
      class="slider-box relative w-full flex justify-between group md-buttons-aside " 
    >
      <base-slider-item
        v-for="(slide, i) in slides"
        :key="slide"  
        :transition-effect="transitionEffect"    
        :data-index="i"
        :slide="slide"
        :current-slide="currentSlideIndex === i"
        class="slide absolute max-h-full h-full overflow-hidden" 
        :class="contenidoClasses"   
        :public-path="publicPath" 
        :images-slider="imagesSlider"  
        :slider-height="sliderHeight" 
      />
      <slider-buttons 
        v-if="navigation"
        :next="next" 
        :prev="prev"
        :button-classes="buttonClasses"
        @after="changeSlide('after')"
        @before="changeSlide('before')"
      ></slider-buttons>
      <pagination-slider
        v-if="pagination"
        :slides="slides"
        :mode="paginationClasses"
        :position="paginationPosition"
        :slide-selected="currentSlideIndex"
        @change-page="changeSlide"        
      ></pagination-slider>
    </div>
  </div> 
</template>

<script>

import BaseSliderItem from './BaseSliderItem.vue'
import SliderButtons from './SliderButtons.vue'
import paginationSlider from './paginationSlider.vue'

export default {
  components: {
    BaseSliderItem,
    SliderButtons,   
    paginationSlider
  },
  props: {
    prev: {
      type: Object,
      required: false,
      default: () => {
        return {
          icon: true,
          text: "",
          shadow:true,
          circle:true,
          width: "3rem"
        }
      }
    },
    next: {
      type: Object,
      required: false,
      default: () => {
        return {
          icon: true,
          text: "",
          shadow:true,
          circle:true,
          width: "3rem"
        }
      }
    },
    contenidoClasses: {
      type: String,
      requiered: false,
      default: "",
    },
    boxClasses: {
      type: String,
      requiered: false,
      default: "w-full md:w-5/6",
    },
    buttonClasses: {
      type: String,
      requiered: false,
      default: "hidden group-hover:inline-block",
    },
    slides: {
      type: [Object, Array],
      required: false,
      default: () => {}
    },
    sliderSize:  {
      type: [Number, String],
      required: false,
      default: 3
    },
    autoPlay: {
      type: Boolean,
      required: false,
      default: true
    },
    navigation: {
      type: Boolean,
      required: false,
      default: true
    },
    pagination: {
      type: Boolean,
      required: false,
      default: true
    },
    paginationClasses: {
      type: String,
      requiered: false,
      default: "bg-white hover:opacity-100 opacity-50",
    },
    paginationPosition: {
      type: String,
      requiered: false,
      default: "bottom-0",
    },
    timeSlider: {
      type: Number, 
      required: false,
      default: 3000
    },
    publicPath: {
      type: [Object, String],
      requiered: false,
      default: process.env.BASE_URL
    },
    imagesSlider: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderHeight: {
      type: String,
      requiered: false,
      default: 'h-full'
    }
  },
  data() {
    return {
      currentSlideIndex: 0,
      touch: {
        startX: 0,
        endX: 0,
      },
      sliderInterval: null,
      transitionEffect: 'slide-in'
    };
  },
  mounted() {
    if (this.autoPlay) {
      this.OnAutoPlay()
    }
  },
  beforeUnmount() {
    clearInterval(this.sliderInterval);
  },
  methods: {
    OnAutoPlay() {
      //console.log("autoplay");
      this.sliderInterval = setInterval( () => {
        this.changeSlide('auto')
      }, this.timeSlider)
    },
    comienzoTouch(e) {
      //console.log(e.touches[0].clientX);
      this.touch.startX = e.touches[0].clientX;
      this.touch.endX = 0;
    },
    movimientoTouch(e) {
      //console.log(e.touches[0].clientX);
      this.touch.endX = e.touches[0].clientX;
    },
    finalTouch() {
      //console.log("termina");
      if (Math.abs(this.touch.endX - this.touch.startX) < 20) {
        return;
      }

      // if (this.touch.endX < this.touch.startX) {
      //   this.$emit("change-one", "after");
      // } else {
      //   this.$emit("change-one", "before");
      // }
    },
    changeSlide(to) {
      if (to == "before") {
       // console.log('change slide before')
        clearInterval(this.sliderInterval);
        this.transitionEffect = 'slide-out';
        if (this.currentSlideIndex > 0) {
          this.currentSlideIndex = this.currentSlideIndex - 1
        } else {
          this.currentSlideIndex = this.sliderSize - 1 
        }      
      } else if (to == "after")  {
       // console.log('change slide after')
        clearInterval(this.sliderInterval);
        this.transitionEffect = 'slide-in';
        this.advance()
      } else if (to == "auto")  {
       // console.log('change slide auto')
        this.transitionEffect = 'slide-in';
        this.advance()
      } else {
        //console.log(`change to ${to} slide`)
        clearInterval(this.sliderInterval);
        if (this.currentSlideIndex > to) {
          this.transitionEffect = 'slide-out';
          this.currentSlideIndex = to;
        } else if (this.currentSlideIndex < to){
          this.transitionEffect = 'slide-in';
          this.currentSlideIndex = to;
        }
      }      
      //console.log(this.currentSlideIndex)
    },
    advance(){
      if (this.currentSlideIndex < (this.sliderSize-1)){
        this.currentSlideIndex += 1
      } else {
        this.currentSlideIndex = 0;
      }
    }
  },
};
</script>

<style scoped>
  .slider-box {
    max-height: 60vw;
    height:60vh;
  }

  @media screen and (min-width: 768px) {
    .slider-box {
      max-height: 60vh;
      height:60vh;
    }

    .md-buttons-aside {


      /* md:left-1/2 md:transform md:-translate-x-1/2 md:w-4/5  */
    }

  }
</style>